import {createAction} from '@reduxjs/toolkit';

export const setActiveCollectionId = createAction(
  'featureCollections/setActiveCollectionId'
);

export const setActiveCollection = createAction(
  'featureCollections/setActiveCollection'
);

export const setActiveCollectionTitleProp = createAction(
  'featureCollections/setActiveCollectionTitleProp'
);

export const setActiveFeature = createAction(
  'featureCollections/setActiveFeature'
);
